import { buildWorkOrdersAndBomsString } from '@/utils/packingListCodes'

export const FILTER_DEBOUNCE_MS = 200

export function indexById(records) {
    const byId = {}
    ;(records || []).forEach(record => {
        if (record && record.id) {
            byId[record.id] = record
        }
    })
    return byId
}

export function formatTimestampLabel(value) {
    const seconds = value && (value.seconds || value._seconds)
    if (!seconds) {
        return ''
    }
    const date = new Date(seconds * 1000)
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${date.getFullYear()}-${month}-${day}`
}

export function calculateNetMass(pl) {
    return (
        pl.packages?.reduce((acc, pkg) => {
            return (
                acc +
                (pkg.items?.reduce((itemAcc, item) => {
                    return itemAcc + Number(item.packingMass || 0)
                }, 0) || 0)
            )
        }, 0) || 0
    )
}

export function calculateGrossMass(pl, netMass) {
    const net = netMass != null ? netMass : calculateNetMass(pl)
    const crates =
        pl.packages?.reduce((acc, pkg) => {
            return acc + Number(pkg.packageDimensions?.mass || 0)
        }, 0) || 0
    return net + crates
}

function userName(usersById, id) {
    const user = usersById && usersById[id]
    return user ? user.name : ''
}

export function projectRecord(projectsById, id) {
    return (
        (projectsById && projectsById[id]) || {
            reference: '',
            name: '',
        }
    )
}

export function decoratePackingList(packingList, usersById, projectsById) {
    packingList.selectedWorkOrdersAndBomsString = buildWorkOrdersAndBomsString(
        packingList
    )
    const netMass = calculateNetMass(packingList)
    packingList.netMass = netMass.toFixed(1)
    packingList.grossMass = calculateGrossMass(packingList, netMass).toFixed(1)
    packingList.createdByName = userName(usersById, packingList.createdBy)
    packingList.shippedByName = userName(usersById, packingList.shippedBy)
    const project = projectRecord(projectsById, packingList.projectId)
    packingList.projectLabel = `${project.reference} - ${project.name}`
    packingList.createdOnLabel = formatTimestampLabel(packingList.createdOn)
    packingList.shippedOnLabel = packingList.shippedOn
        ? formatTimestampLabel(packingList.shippedOn)
        : ''
    packingList.completedOnLabel = packingList.completedOn
        ? formatTimestampLabel(packingList.completedOn)
        : ''
    return packingList
}

export function normalizeFilter(value) {
    return value ? String(value).toLowerCase() : ''
}
